<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>会员卡设置</div>
                </div>
            </div>

            <el-table :data="listArr">
                <el-table-column
                    v-for="title in tableTitleList"
                    :prop="title.prop"
                    :label="title.name"
                    align="center">
                </el-table-column>
            </el-table>



            <div class="admin_form_main">
                <el-tabs tab-position="left" style="min-height: 200px;">
                    <el-tab-pane label="VIP1"><wxpayMini></wxpayMini></el-tab-pane>
                    <el-tab-pane label="VIP2"><alipayApp></alipayApp></el-tab-pane>
                    <el-tab-pane label="VIP3"><alipayPc></alipayPc></el-tab-pane>
                    <el-tab-pane label="VIP4"><zongdzf></zongdzf></el-tab-pane>

                    <!--<el-tab-pane label="支付宝APP"><alipayApp></alipayApp></el-tab-pane>
                    <el-tab-pane label="支付宝PC"><alipayPc></alipayPc></el-tab-pane>-->
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import wxpayH5 from '@/components/admin/pay/wxpay_h5'
    import wxpayApp from '@/components/admin/pay/wxpay_app'
    import wxpayJsApi from '@/components/admin/pay/wxpay_jsapi'
    import wxpayMini from '@/components/admin/pay/wxpay_mini'
    import alipayH5 from '@/components/admin/pay/alipay_h5'
    import alipayPc from '@/components/admin/pay/alipay_pc'


    import zongdzf from '@/components/admin/pay/zongdzf'
    import dailzf from '@/components/admin/pay/dailzf'
    import putzf from '@/components/admin/pay/putzf'


    import alipayApp from '@/components/admin/pay/alipay_app'
    import shiysmApp from '@/components/admin/pay/shiysm_app'
    export default {
        components: {
            wxpayH5,
            wxpayApp,
            wxpayJsApi,
            wxpayMini,
            alipayH5,
            alipayPc,
            alipayApp,
            shiysmApp,
            zongdzf,
            dailzf,
            putzf
        },
        props: {},
        data() {
            return {
                listArr:[
                    {
                        purposeSystem:"系统一",
                        serveName:"测试服务一"
                    },
                    {
                        purposeSystem:"系统二",
                        serveName:"测试服务二"
                    }
                ],
                tableTitleList:[
                    {prop:"purposeSystem",name:"目的系统"},
                    {prop:"serveName",name:"服务名称"}
                ]
            };
        },
        watch: {},
        computed: {},
        methods: {},
        created() {},
        mounted() {}
    };
</script>
<style lang="scss" scoped>

</style>
